import React from 'react';
import styled from '@emotion/styled';

import Icon from 'app/components/commons/Icon';

const StyledIcon = styled(Icon)({
  verticalAlign: 'text-top'
});

const CasualContestIcon = ({ size }) => (
  <StyledIcon type="icon-pyramid-chart" size={size} color="#01a17e" />
);

export default CasualContestIcon;
